let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("7zMjZ"), load("a1dBM"), load("7FkEF"), load("4VAcx")]).then(() => parcelRequire('4E0H6'));